import React, { useEffect } from "react";
import { usePlatformBranding, platformLogoUrl, isLightColor, PoweredByFooter, applyTheme } from "../../lib/branding";

export function useLoginTheme(isBO: boolean) {
  const { data: pb } = usePlatformBranding();
  useEffect(() => { applyTheme(isBO, pb); }, [isBO, pb]);
  const color = isBO ? "#0B024A" : pb?.primary_color || "#10046E";
  const light = !isBO && isLightColor(color);
  const secondary = isBO ? "#EEBD0A" : pb?.secondary_color || "#EEBD0A";
  const accent = isBO ? "#EEBD0A" : isLightColor(secondary) === light ? (light ? "#10046E" : "#EEBD0A") : secondary;
  const logo = isBO || !pb?.portal_logo_file_id ? "/enfleet-logo.png" : platformLogoUrl("portal", pb.portal_logo_file_id);
  return { pb, color, light, fg: light ? "#0f172a" : "#ffffff", muted: light ? "rgba(15,23,42,0.6)" : "rgba(255,255,255,0.7)", accent, logo, alt: pb?.company_name || "ENFLEET by POMEN" };
}

export function AuthLayout({ isBO, eyebrow, headline, bullets, children, testId }: { isBO: boolean; eyebrow: string; headline: string; bullets: string[]; children: React.ReactNode; testId: string }) {
  const t = useLoginTheme(isBO);
  if (!isBO && !t.pb) return <div className="min-h-screen bg-white" data-testid="branding-loading" />;
  return (
    <div className="grid min-h-screen lg:grid-cols-[1.2fr_1fr]" data-testid={testId}>
      <div className="grain relative hidden flex-col justify-between p-10 lg:flex" style={{ background: t.color, color: t.fg }}>
        <img src={t.logo} alt={t.alt} className="h-10 max-w-[200px] self-start object-contain" data-testid="login-logo" />
        <div className="rise">
          <p className="text-xs font-semibold uppercase tracking-[0.2em]" style={{ color: t.accent }}>{eyebrow}</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold leading-tight">{headline}</h1>
          <ul className="mt-6 space-y-2 text-sm" style={{ color: t.muted }}>
            {bullets.map((b) => <li key={b} className="flex items-center gap-2"><span className="h-1 w-1 rounded-full" style={{ background: t.accent }} />{b}</li>)}
          </ul>
        </div>
        <PoweredByFooter backOfficeLink={!isBO} className={t.light ? "text-slate-500" : "text-white/40"} />
      </div>
      <div className="flex items-center justify-center bg-slate-50 p-6">
        <div className="w-full max-w-sm">
          <div className="mb-6 flex justify-center rounded-xl py-4 lg:hidden" style={{ background: t.color }}><img src={t.logo} alt={t.alt} className="h-9 max-w-[180px] object-contain" /></div>
          {children}
        </div>
      </div>
    </div>
  );
}
